import Cookies from "js-cookie";
import { endPoints } from "../../constant/api_constants/url";
import { APP_URL, environment } from "../../constant/environment";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";
import { consoleLog } from "../../utils/consoleLog/consoleLog";

export const sendResetPasswordLink = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.sendResetPassword;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);
};

export const resetPassword = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.resetPassword;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);
};

export const getUserDetailsByToken = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.getUserDetailByToken;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, { token: payload });
};

export interface captchaVerificationAPIArgs {
  token: string;
}

export const captchaVerificationAPI = async (accessJWT: string, payload: captchaVerificationAPIArgs): Promise<any> => {
  const endpoint = endPoints.captchaVerification;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);
};

// export const logout = async (payload: any): Promise<any> => {
//   const endpoint = endPoints.logout;
//   return await fetchApi(endpoint, API_METHODS.POST, payload);
// };

export const logout = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.logout;
  try {
    const response = await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);

    // Remove cookies in this function as well
    Cookies.remove(`${environment}userData`, {
      path: "/",
      domain: ".zenvoya.ai",
    });

    return response;
  } catch (error) {
    console.error("Logout API error:", error);
    throw error;
  }
};

export const login = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.login;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);
};

export const getGoogleAuth = async (accessJWT: string, payload: any): Promise<any> => {
  consoleLog({
    code: "4/0Ab32j91NLB2iTadRJgtCtS8rHkkf74pM4PFpSGxDOpl6saWblJXf-TWVeTqTaQObcd1FVg",
    redirectUri: `${APP_URL}app/code`,
  });
  const endpoint = endPoints.login;
  console.log("endpoint", endpoint);
  return await fetchApi(accessJWT, "google/verifyCode", API_METHODS.POST, payload);
};

export const getTemplateDetails = async (accessJWT: string, payload: any): Promise<any> => {
  const endpoint = endPoints.template;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, payload);
};
